// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"AccountCheckbox_Checkbox__AYA7v"};